import { styled } from '@mui/material';

export const StyledActionsWrapper = styled('div')(() => {
  return {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1,
    gap: 16,
  };
});
